import React, {
  ReactElement,
} from 'react';
import { useIntl } from 'react-intl';
import Table, {
  TableBody, TableContainer, TableRow, SocialMediaValueCell,
  SocialMediaTableCells,
} from '@fuww/library/src/Table';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import IntelligencePageLayout from '@fuww/library/src/Layouts/IntelligencePage';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import Hero from '../components/Hero';
import Head from '../components/Head';
import twitterPages from '../data/staticPages/i/twitter-fashion-index.json';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import FashionIndexTableHead from '../components/FashionIndex/TableHead';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/Sj1Xvx-EG3FV2yxR5gvdVa3B9YGv9_S7jxOe3b0m0Xc/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/bGv-KDLhPHzTp-dOPitJ3qI31O-R-_3Vy09YDu-mKYA/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/pBWdVpjil_tYb1KFIdIrxqlS5hM2fvQWm-NOUKMibJw/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfbW9iaWxlLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/xgarAU3r3hWRKbCvfeewzXOkwBzbBv73qvSDWDOIY4k/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/NkgiTdU3UThpZuItaqcMwjl_ch5fIv2q8btjDVtjpjA/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/lnZQefQ2WLG9KeuseKW1zTyPaPGD8FnQXXtilwBwHiI/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/NpBhOeMPOcPolYWozLiojXWJPf_glG4U-BbnplfbX9I/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHdpdHRlcl9pbmRleF9iYW5uZXJfZGVza3RvcC5qcGc',
  ],
};

const TwitterFashionIndexPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'twitter-fashion-index',
    'twitterFashionIndex',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['twitterFashionIndex.title'])}
        description={intl.formatMessage(
          messages['twitterFashionIndex.description'],
        )}
      />
      <IntelligencePageLayout
        description={
          intl.formatMessage(messages['twitterFashionIndex.description'])
        }
        content={(
          <>
            <TableContainer>
              <Table aria-label={intl.formatMessage(
                messages['twitterFashionIndex.table.ariaLabel'])}
              >
                <FashionIndexTableHead alignRight />
                <TableBody>
                  {twitterPages.map(({ brand, followers, link }, index) => (
                    <TableRow key={brand}>
                      <SocialMediaTableCells
                        index={index + 1}
                        link={link}
                        value={brand}
                      />
                      <SocialMediaValueCell value={followers} alignRight />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'twitterFashionIndex.source'
              ]),
            }}
            />
          </>
        )}
        breadcrumbs={breadcrumbs}
        subTitle={intl.formatMessage(messages['twitterFashionIndex.subTitle'])}
        title={intl.formatMessage(messages['twitterFashionIndex.title'])}
      />
    </>
  );
};

TwitterFashionIndexPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        imageUrls={headerImageUrls}
        alt="Twitter Fashion Index"
      />
    )}
  >
    {page}
  </Layout>
);

TwitterFashionIndexPage.getInitialProps = redirectRouteToDomain(
  'twitter-fashion-index',
);

export default TwitterFashionIndexPage;
